import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import * as mapboxgl from 'mapbox-gl';
import * as turf from '@turf/turf';
import moment from 'moment';
import { environment } from 'src/environments/environment';
import { MapsService } from './services/maps.service';
import { MonitoredVehicleJourney, StopPredictions, Stop, StopsNBIQ, Agencies, AllStopsNBIQ, AgenciesOperator, AgenciesOperators, AgencyV1, Value, AddStops} from './types/types';
import { ActivatedRoute } from '@angular/router';
import { Subscription, interval } from 'rxjs';
import { Router } from '@angular/router';
import { AppConfigService } from './services/app-config/app-config.service';

@Component({
  selector: 'nearby-map',
  templateUrl: './maps.component.html',
  styleUrls: ['./maps.component.less']
})

export class MapsComponent implements OnInit {

  @ViewChild('nearByStopsPredictionsNbIq', {static: false}) nearByStopsPredictionsNbIq: ElementRef;
  @ViewChild('nearByStopsPredictions', {static: false }) nearByStopsPredictions: ElementRef;

  constructor(
    private mapsService: MapsService,
    private route: ActivatedRoute,
    private router: Router,
    private appConfigService: AppConfigService
  ) {this.nearbyAppKeys = this.appConfigService.getConfig(); }

  public agencies: any = [];
  public operators: any = [];
  public queryParams: string = null;
  public primaryOperator = false;
  public operatorId: string = null;
  public stopCodeParam: string = null;
  public stopCode: string = null;
  public signedLocationLon: number = null;
  public signedLocationLat: number = null;
  public nearByStopLocationLon: number;
  public nearByStopLocationLat: number;
  public nearbyEachStopSource: any = [];
  public noMonitoredVehicleJourney: any = [];
  public noPredictionBubbles = false;
  public signedLocationsId: string = null;
  public nearByStopsColorCode: string = null;
  public totalItems: number = null;
  public bubbleCssClass: any[] = [];
  public popup: any = null;
  public defaultPostionIndex = 1;
  public totalStopCodes: any = [];
  public allStops: any = [];
  public addStops: {} = {};
  public nearbyAppKeys: any = {};

  public distanceOfSignedLocation: any = [];
  public routeKeys: any = [];
  public routeKeysNbIq: any = [];
  public routeKeysNoDataNbIq: any = [];
  public routeKeysNoDataCN = false;
  public routeKeysNoDataFail = false;
  public routeColor: string[] = [];
  public stopTimes: Value[] = [];
  public bubbles = false;
  public bubblesNbIq = false;
  public zoomLevel: number = environment.zoom_level;
  public refreshPredictionsArrayNbIq: any = [];
  public refreshPredictionsArray: any = [];
  public innerWidth: number;
  public getParams = true;
  public popupBlock = false;
  public getParamLng: number = null;
  public getParamLat: number = null;
  public getParamZoom: number = null;
  public getParamRefreshRate: number = null;
  public getParamNotification: string = null;
  public markerLocationOverrideLat: string = null;
  public markerLocationOverrideLng: string = null;
  public stopPostionIndexValue: number = null;
  public source = interval(1);
  public localTime: string = null;

  public agencyIdError: any = [];

  public nearbyStopPointOne: any;
  public nearbyStopPointTwo: any;
  public placeIndexOne: number;
  public placeIndexTwo: number;
  public placeIndexThree: number;
  public placeIndexFour: number;
  public valueOfPlaceIndexFour: any;
  public valueOfPlaceIndexThree: any;

  public nearbyStopPointThirdAngle: any;
  public nearbyStopPointFourthAngle: any;

  public differenceOfLocationslengthIndexThree: number;
  public differenceOfLocationslengthIndexFour: number;
  public valueOfPlaceIndexFourTop = 448;

  public currentAgencyId = 'sfmta-cis';

  public addLineIndexFour: any = 'bubbleLeft';
  public addLineIndexThree: any =  'bubbleTop';
  public screenSize: number;
  public screenBubbleAlignCss = false;
  public screenBubbleAlignCssMd = false;

  private defaultRefreshRate: number = environment.refresh_rate;
  private defaultNotification: string = environment.alerts;
  private subscription: Subscription;
  private localTimesubscription: Subscription;
  private nearByStopsColor: string = environment.near_by_stops_color_code;
  private mainMapZoomLevel: number = environment.default_map_zoom_level;
  private defaultMapLocation: any = environment.default_map_location;
  private zoomControls: string = environment.zoom_control;

  public map!: mapboxgl.Map;

  public ngOnInit(): void {
    this.getAgencies();
    this.getOperators();

    this.route.queryParamMap.subscribe((queryParamMap: any) => {

      if (this.getParams) {

        this.queryParams = queryParamMap.keys[0];

        if (this.queryParams) {

          this.queryParams.split(',').forEach((val, i) => {

            this.operatorId = val.split(':')[0];
            this.stopCode = val.split(':')[1];
            this.addStops = {
              operatorId: this.operatorId,
              stopCode:  this.stopCode
            };
            if (i === 0) {
              this.allStops.push(this.addStops);

            } else {
              this.totalStopCodes.push(this.addStops);
            }
          });
        }
       }

      this.getParamLng = queryParamMap.get('lng');
      this.getParamLat = queryParamMap.get('lat');
      this.getParamZoom = queryParamMap.get('zoomvalue');
      this.getParamRefreshRate = queryParamMap.get('refresh');
      this.getParamNotification = queryParamMap.get('alerts');
      this.markerLocationOverrideLat = queryParamMap.get('UhereLat');
      this.markerLocationOverrideLng = queryParamMap.get('UhereLng');

      if (!this.getParamNotification && this.getParamNotification === null) {
        this.getParamNotification = this.defaultNotification;
      }
      if (!this.getParamRefreshRate && this.getParamRefreshRate === null) {
        this.getParamRefreshRate = this.defaultRefreshRate;
      }
      this.subscription = interval(this.getParamRefreshRate).subscribe(() => {

        const internal = 200;

        if (this.refreshPredictionsArrayNbIq.length >= 1) {
            this.refreshPredictionsArrayNbIq.forEach((val: any, i: any) => {
              setTimeout(() => {
                this.popupBlock = true;
                this.getStopPredictionsNbIq(val.agencyNb, val.stopCodeNb, val.longitudeNb, val.latitudeNb, val.totalItemsNb, val.stopPostionIndexValueNb);
              }, i * internal);
            });

            this.refreshPredictionsArrayNbIq = [];
        }
        if (this.refreshPredictionsArray.length >= 1) {

            this.refreshPredictionsArray.forEach((val: any, i: any) => {
            setTimeout(() => {
              this.popupBlock = true;
              this.getStopPredictions(val.agencyRf, val.stopCodeRf,  val.operatorRefRf, val.longitudeRf, val.latitudeRf, val.totalItemsRf);
              }, i * internal);
            });
            this.refreshPredictionsArray = [];
        }
      });

      this.localTimesubscription = this.source.subscribe(val => this.localTime = moment().format('LT'));

    });

    this.map = new mapboxgl.Map({
        accessToken: this.nearbyAppKeys.mapbox_api_key,
        container: 'map',
        center: this.defaultMapLocation,
        style: this.nearbyAppKeys.mapbox_style,
        zoom: this.mainMapZoomLevel,
    });

    if (this.zoomControls === 'on') {
      this.map.addControl(new mapboxgl.NavigationControl());
    }

  }

  public getAgencies(): void {
    this.mapsService.getAgencies(this.currentAgencyId).subscribe(
        (response: Agencies) => {
          [response].forEach((getAgency: any) => {
            if (Array.isArray(getAgency)) {
              this.agencies = getAgency;
            } else {
              this.agencies = [getAgency];
            }
          });
        },
        (error: any) => {
          this.getStopParams();
          console.log(error);
        },
        () => {
          this.getStopParams();
        },
    );
  }

  public getOperators(): void{

    this.mapsService.getOperators().subscribe(

      (response: AgenciesOperators) => {

        [response].forEach((getOperators: any) => {

         this.operators = getOperators;

        });

      },

      (error: any) => { console.log(error); },
      () => {},
    );
  }

  public getStopParams(): void {

    setTimeout(() => {
      const uniqueStopCodes = Array.from(new Set(this.totalStopCodes.map((a: AddStops) => a.stopCode)))
      .map(stopCode => {
        return this.totalStopCodes.find((a: AddStops) => a.stopCode === stopCode);
      });

      uniqueStopCodes.forEach((val) => this.allStops.push(val));

      this.totalStopCodes = this.allStops;

      if (this.totalStopCodes.length >= 1) {

          let delay = 1800;

          if (this.totalStopCodes.length >= 4 && this.getParamRefreshRate > 19500) {
            delay = 2100;
          }
          if (this.totalStopCodes.length >= 4 && this.getParamRefreshRate <= 19500) {
            delay = 1200;
          }

          this.totalStopCodes.forEach((addStops: AddStops, i: number) => {

            setTimeout(() => {
              this.nearByStopsColorCode = this.nearByStopsColor;
              this.distanceOfSignedLocation = [];

              i === 0 ? this.primaryOperator = true : this.primaryOperator = false;

              this.totalItems = i;
              this.stopPostionIndexValue = null;
              if (this.agencies.length > 0) {
                this.agencies.forEach((agencyKey: AgencyV1) => {
                  if (agencyKey.id === addStops.operatorId) {
                    this.routeKeysNbIq = [];
                    this.getSignedLocationsNbIq(
                      this.primaryOperator,
                      addStops.operatorId,
                      addStops.stopCode,
                      this.totalItems,
                      this.nearByStopsColorCode,
                      this.stopPostionIndexValue);
                  }
                });
              }


              if (this.operators.length > 0) {
                this.operators.forEach((operatorId: AgenciesOperator) => {
                  if (operatorId.Id === addStops.operatorId) {
                    this.getSignedLocations(this.primaryOperator, addStops.operatorId, addStops.stopCode, operatorId.SiriOperatorRef, this.totalItems, this.nearByStopsColorCode);
                  }
                });
              }

            }, i * delay);

          });
      }
    }, 1500);

    // AgencyId Error Notification
    setTimeout(() => {

      if (this.agencies.length > 0) {
        this.agencyIdError = this.totalStopCodes.filter((x: any) => !this.agencies.some((y: any) => y.id === x.operatorId));
      }
      setTimeout(() => {
        if (this.operators.length > 0) {
          const operatorsFilter = this.agencyIdError.filter((x: any) => !this.operators.some((y: any) => y.Id === x.operatorId));
          const IdError: any = {};
          this.agencyIdError = [];
          operatorsFilter.forEach((x: any) => {
            if (!IdError[x.operatorId]) {
              IdError[x.operatorId] = true;
              this.agencyIdError.push(x);
            }
          });
        }
        const triggeredStatus = {
          trigger: 'Triggered',
          // tslint:disable-next-line
          currentUrl: this.router['location']._platformLocation.location.origin + '/?' + this.queryParams
        };

        if (this.agencyIdError.length > 0) {
          let agencyIdErrorSummary: any = {};
          if (this.getParamNotification === 'on') {

            if (localStorage.getItem('oneTime') === null || localStorage.getItem('oneTime') === '1') {
              let lastSeenTimeAgencyError = null;
              if (localStorage.getItem('agencyUrl') === triggeredStatus.currentUrl) {
                  triggeredStatus.trigger = 'Retriggered';
                  lastSeenTimeAgencyError = localStorage.getItem('lastSeenTime');
              } else {
                lastSeenTimeAgencyError = moment.utc().format();
                localStorage.setItem('agencyUrl', triggeredStatus.currentUrl);
                localStorage.setItem('lastSeenTime',  lastSeenTimeAgencyError);
              }

              agencyIdErrorSummary = {
                summary : 'invalid agency',
                status: '4',
                lastSeentimestamp: lastSeenTimeAgencyError,
                timeISO: moment().toISOString(true),
                url: triggeredStatus.currentUrl + '&alerts=off',
                triggerStatus: triggeredStatus.trigger
              };
              if (localStorage.getItem('oneTime') === null) {
                localStorage.setItem('oneTime', '0');
              }
              this.agencyIdError.push(agencyIdErrorSummary);
              this.mapsService.sendEmail(this.agencyIdError).subscribe();
            }
            if (localStorage.getItem('oneTime') === '0' ||
                localStorage.getItem('oneTime') === '1' ||
                localStorage.getItem('oneTime') === '2' ||
                localStorage.getItem('oneTime') === '3' ||
                localStorage.getItem('oneTime') === '4' ||
                localStorage.getItem('oneTime') === '5') {
              const oneTime = (parseInt(localStorage.getItem('oneTime'), 0) + 1);
              localStorage.setItem('oneTime', oneTime.toString());
            }

            if (localStorage.getItem('oneTime') === '6') {
              localStorage.removeItem('oneTime');
              localStorage.removeItem('agencyUrl');
              localStorage.removeItem('lastSeenTime');
            }

          }

          if (this.getParamNotification === 'off') {
              agencyIdErrorSummary = {
                summary : 'invalid agency',
                url: triggeredStatus.currentUrl + '&alerts=off',
              };
              console.log('Errors', agencyIdErrorSummary);
          }

        }
      }, 1000);
    }, 5500);

    this.innerWidth = window.innerWidth;
  }

  public getSignedLocations(
    primaryOperator: boolean,
    operatorId: string,
    stopCode: string,
    operatorRef: string,
    totalItems: number,
    nearByStopsColorCode: string): void {

    this.mapsService.getStops(operatorId, stopCode).subscribe(

      (response: Stop) => {

          this.signedLocationsId = stopCode;

          if (primaryOperator) {
              this.signedLocationLon = response.Siri.ServiceDelivery.DataObjectDelivery.dataObjects.SiteFrame.stopPlaces.StopPlace.Centroid.Location.Longitude;
              this.signedLocationLat = response.Siri.ServiceDelivery.DataObjectDelivery.dataObjects.SiteFrame.stopPlaces.StopPlace.Centroid.Location.Latitude;
            if (this.markerLocationOverrideLat && this.markerLocationOverrideLng){
              this.stopLocation(+this.markerLocationOverrideLng, +this.markerLocationOverrideLat);
            }else{
              this.stopLocation(this.signedLocationLon, this.signedLocationLat);
            }
            } else {
              this.nearByStopLocationLon = response.Siri.ServiceDelivery.DataObjectDelivery.dataObjects.SiteFrame.stopPlaces.StopPlace.Centroid.Location.Longitude;
              this.nearByStopLocationLat = response.Siri.ServiceDelivery.DataObjectDelivery.dataObjects.SiteFrame.stopPlaces.StopPlace.Centroid.Location.Latitude;
              this.getNearByStopPoints(this.nearByStopLocationLon,  this.nearByStopLocationLat);
          }

          if ((!primaryOperator && totalItems === 1) || (!primaryOperator && totalItems === 2) || (!primaryOperator && totalItems === 5) || (!primaryOperator && totalItems === 6)) {
            this.map.addSource('nearByStops' + this.signedLocationsId, {
              type: 'geojson',
              data: {
                  type: 'FeatureCollection',
                  features: this.nearbyEachStopSource
                  }
            });
            this.map.addLayer({
              id: 'signedLocation' + this.signedLocationsId,
              type: 'circle',
              source: 'nearByStops' + this.signedLocationsId,
              paint: {
                  'circle-color': nearByStopsColorCode,
                  'circle-radius': 8,
                  'circle-stroke-width': 2,
                  'circle-stroke-color': '#d6d6d6'
                }
            });

            this.getStopPredictions(operatorId, stopCode, operatorRef, this.nearByStopLocationLon, this.nearByStopLocationLat,  totalItems);
          }

          if (!primaryOperator && totalItems === 3) {

            this.map.addSource('nearByStops' + this.signedLocationsId, {
              type: 'geojson',
              data: {
                  type: 'FeatureCollection',
                  features: this.nearbyEachStopSource
                  }
            });
            this.map.addLayer({
              id: 'signedLocation' + this.signedLocationsId,
              type: 'circle',
              source: 'nearByStops' + this.signedLocationsId,
              paint: {
                  'circle-color': nearByStopsColorCode,
                  'circle-radius': 8,
                  'circle-stroke-width': 2,
                  'circle-stroke-color': '#d6d6d6'
                }
            });
            const el = document.createElement('div');
            el.id = 'bubbleTop';
            new mapboxgl.Marker(el).setLngLat([this.nearByStopLocationLon, this.nearByStopLocationLat]).addTo(this.map);
            this.getStopPredictions(operatorId, stopCode, operatorRef, this.nearByStopLocationLon, this.nearByStopLocationLat,  totalItems);
          }

          if (!primaryOperator && totalItems === 4) {

            this.map.addSource('nearByStops' + this.signedLocationsId, {
              type: 'geojson',
              data: {
                  type: 'FeatureCollection',
                  features: this.nearbyEachStopSource
                  }
            });
            this.map.addLayer({
              id: 'signedLocation' + this.signedLocationsId,
              type: 'circle',
              source: 'nearByStops' + this.signedLocationsId,
              paint: {
                  'circle-color': nearByStopsColorCode,
                  'circle-radius': 8,
                  'circle-stroke-width': 2,
                  'circle-stroke-color': '#d6d6d6'
                }
            });

            const el = document.createElement('div');
            el.id = 'bubbleLeft';
            new mapboxgl.Marker(el).setLngLat([this.nearByStopLocationLon, this.nearByStopLocationLat]).addTo(this.map);
            this.getStopPredictions(operatorId, stopCode, operatorRef, this.nearByStopLocationLon, this.nearByStopLocationLat,  totalItems);
          }

      },

      (error: any) => console.log(error),
      () => {},
    );
  }

  public getSignedLocationsNbIq(
    primaryOperator: boolean,
    operatorId: string,
    stopCode: string,
    totalItems: number,
    nearByStopsColorCode: string,
    stopPostionIndexValue: number): void {

    this.mapsService.getStopsNbIq(operatorId, stopCode).subscribe(

      (response: StopsNBIQ) => {

        this.signedLocationsId = null;

        [response].forEach((stopNbIq: any) => {

          this.signedLocationsId = stopCode;

          if (primaryOperator) {
            this.signedLocationLon = stopNbIq[0].lon;
            this.signedLocationLat = stopNbIq[0].lat;

          } else {
            this.nearByStopLocationLon = stopNbIq[0].lon;
            this.nearByStopLocationLat = stopNbIq[0].lat;
          }

          if (primaryOperator) {
            if (this.markerLocationOverrideLat && this.markerLocationOverrideLng) {
              this.stopLocation(+this.markerLocationOverrideLng, +this.markerLocationOverrideLat);
            } else {
              this.stopLocation(this.signedLocationLon, this.signedLocationLat);
            }
          } else {
            this.getNearByStopPoints(this.nearByStopLocationLon,  this.nearByStopLocationLat);
          }
          if ((!primaryOperator && totalItems === 1) || (!primaryOperator && totalItems === 2) || (!primaryOperator && totalItems === 5) || (!primaryOperator && totalItems === 6)) {
            this.map.addSource('nearByStops' + this.signedLocationsId, {
              type: 'geojson',
              data: {
                  type: 'FeatureCollection',
                  features: this.nearbyEachStopSource
                }
            });

            this.map.addLayer({
              id: 'signedLocation' + this.signedLocationsId,
              type: 'circle',
              source: 'nearByStops' + this.signedLocationsId,
              paint: {
                  'circle-color': nearByStopsColorCode,
                  'circle-radius': 8,
                  'circle-stroke-width': 2,
                  'circle-stroke-color': '#d6d6d6',
                }
            });

            this.getStopPredictionsNbIq(operatorId, stopCode,  this.nearByStopLocationLon, this.nearByStopLocationLat, totalItems, stopPostionIndexValue);
          }

          if (!primaryOperator && totalItems === 3) {

            this.map.addSource('nearByStops' + this.signedLocationsId, {
              type: 'geojson',
              data: {
                  type: 'FeatureCollection',
                  features: this.nearbyEachStopSource
                }
            });

            this.map.addLayer({
              id: 'signedLocation' + this.signedLocationsId,
              type: 'circle',
              source: 'nearByStops' + this.signedLocationsId,
              paint: {
                  'circle-color': nearByStopsColorCode,
                  'circle-radius': 8,
                  'circle-stroke-width': 2,
                  'circle-stroke-color': '#d6d6d6',
                }
            });

            const el = document.createElement('div');
            el.id = 'bubbleTop';
            new mapboxgl.Marker(el).setLngLat([this.nearByStopLocationLon, this.nearByStopLocationLat]).addTo(this.map);
            this.getStopPredictionsNbIq(operatorId, stopCode,  this.nearByStopLocationLon, this.nearByStopLocationLat, totalItems, stopPostionIndexValue);
          }

          if (!primaryOperator && totalItems === 4) {

            this.map.addSource('nearByStops' + this.signedLocationsId, {
              type: 'geojson',
              data: {
                  type: 'FeatureCollection',
                  features: this.nearbyEachStopSource
                }
            });

            this.map.addLayer({
              id: 'signedLocation' + this.signedLocationsId,
              type: 'circle',
              source: 'nearByStops' + this.signedLocationsId,
              paint: {
                  'circle-color': nearByStopsColorCode,
                  'circle-radius': 8,
                  'circle-stroke-width': 2,
                  'circle-stroke-color': '#d6d6d6',
                }
            });

            const el = document.createElement('div');
            el.id = 'bubbleLeft';
            new mapboxgl.Marker(el).setLngLat([this.nearByStopLocationLon, this.nearByStopLocationLat]).addTo(this.map);
            this.getStopPredictionsNbIq(operatorId, stopCode,  this.nearByStopLocationLon, this.nearByStopLocationLat, totalItems, stopPostionIndexValue);
          }

        });

      },
      (error: any) => {

        if (this.getParamNotification === 'on') {

          const triggeredErrorStatus = {
            trigger: 'Triggered',
            // tslint:disable-next-line
            currentUrl: this.router['location']._platformLocation.location.origin + '/?' + this.queryParams
          };

          let lastSeenTime = null;

          if (localStorage.getItem('oneTimeStopCode') === null || localStorage.getItem('oneTimeStopCode') === '1') {


              if (localStorage.getItem('stopUrl') === triggeredErrorStatus.currentUrl) {
                triggeredErrorStatus.trigger = 'Retriggered';
                lastSeenTime = localStorage.getItem('lastSeenTime');

              } else {
                lastSeenTime = moment.utc().format();
                localStorage.setItem('stopUrl', triggeredErrorStatus.currentUrl);
                localStorage.setItem('lastSeenTime',  lastSeenTime);
              }
              const errorStopCode = {
                unknownStopCode: stopCode,
                stopCodeTrigger: triggeredErrorStatus.trigger,
                lastSeentimestamp: lastSeenTime,
                timeISO: moment().toISOString(true),
                errorInUrl: triggeredErrorStatus.currentUrl + '&alerts=off'
              };

              if ( localStorage.getItem('oneTimeStopCode') === null) {
                localStorage.setItem('oneTimeStopCode',  '0');
              }

              error = {...error,  ...errorStopCode};
              this.mapsService.sendEmail(error).subscribe();
          }
          if (localStorage.getItem('oneTimeStopCode') === '0' ||
              localStorage.getItem('oneTimeStopCode') === '1' ||
              localStorage.getItem('oneTimeStopCode') === '2' ||
              localStorage.getItem('oneTimeStopCode') === '3' ||
              localStorage.getItem('oneTimeStopCode') === '4' ||
              localStorage.getItem('oneTimeStopCode') === '5') {
            const oneTimeStopCode = (parseInt(localStorage.getItem('oneTimeStopCode'), 0) + 1);
            localStorage.setItem('oneTimeStopCode', oneTimeStopCode.toString());
          }

          if (localStorage.getItem('oneTimeStopCode') === '6') {
              localStorage.removeItem('oneTimeStopCode');
              localStorage.removeItem('stopUrl');
              localStorage.removeItem('lastSeenTime');
          }
        }

        console.log(error);
      },
      () => {},
    );
  }

  public getStopPredictions(agency: string, stopCode: string, operatorRef: string, longitude: number, latitude: number, totalItems: number): void {

    this.mapsService.stopPredictions(agency, stopCode).subscribe(
      (response: StopPredictions) => {
        this.routeKeys = [];
        const formatRoutesDataKeys: MonitoredVehicleJourney[] = [];
        let formatedRoutesData: any = [];
        let formatByRouteData: any = [];

        this.screenSize = document.body.offsetWidth;

        const signedLocationGeo: any = {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [this.signedLocationLon, this.signedLocationLat]
          }
        };
        const nearbyStopPoint: any = {
        type: 'Feature',
        geometry: {
            type: 'Point',
            coordinates: [longitude, latitude]
          }
        };
        const units: any = 'miles';
        let differenceOfLocations = (turf.distance(signedLocationGeo, nearbyStopPoint, units)) * 1000;
        differenceOfLocations = Math.floor(differenceOfLocations);
        if (this.defaultPostionIndex === 1) {
          this.nearbyStopPointOne = {
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: [longitude, latitude]
            }
          };
          this.placeIndexOne = differenceOfLocations;
        }
        if (this.defaultPostionIndex === 2) {
          this.nearbyStopPointTwo = {
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: [longitude, latitude]
            }
          };
          this.placeIndexTwo = differenceOfLocations;
        }

        if (this.defaultPostionIndex === 3) {
          this.placeIndexThree = differenceOfLocations;
          const nearbyStopPointThree: any = {
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: [longitude, latitude]
             }
            };
          if (this.nearbyStopPointTwo && this.placeIndexTwo) {
            this.differenceOfLocationslengthIndexThree = (turf.distance(this.nearbyStopPointTwo, nearbyStopPointThree, units)) * 1000;
            this.differenceOfLocationslengthIndexThree = Math.floor(this.differenceOfLocationslengthIndexThree);
            this.nearbyStopPointThirdAngle = Math.acos((((this.placeIndexThree * this.placeIndexThree) + (this.differenceOfLocationslengthIndexThree * this.differenceOfLocationslengthIndexThree)) - (this.placeIndexTwo * this.placeIndexTwo)) / (2 * this.placeIndexThree * this.differenceOfLocationslengthIndexThree));
            this.nearbyStopPointThirdAngle = Math.floor(this.nearbyStopPointThirdAngle * (180 / Math.PI));
          }
        }

        if (this.defaultPostionIndex === 4) {
          this.placeIndexFour = differenceOfLocations;
          const nearbyStopPointFoure: any = {
          type: 'Feature',
          geometry: {
              type: 'Point',
              coordinates: [longitude, latitude]
            }
          };
          if (this.nearbyStopPointOne && this.placeIndexOne) {
            this.differenceOfLocationslengthIndexFour = (turf.distance(this.nearbyStopPointOne, nearbyStopPointFoure, units)) * 1000;
            this.differenceOfLocationslengthIndexFour = Math.floor(this.differenceOfLocationslengthIndexFour);
            this.nearbyStopPointFourthAngle = Math.acos((((this.placeIndexFour * this.placeIndexFour) + (this.differenceOfLocationslengthIndexFour * this.differenceOfLocationslengthIndexFour)) - (this.placeIndexOne * this.placeIndexOne)) / (2 * this.placeIndexFour * this.differenceOfLocationslengthIndexFour));
            this.nearbyStopPointFourthAngle = Math.floor(this.nearbyStopPointFourthAngle * (180 / Math.PI));
          }
        }

        if (this.placeIndexOne < this.placeIndexFour) {
          this.valueOfPlaceIndexFour = this.placeIndexFour;
          if (this.differenceOfLocationslengthIndexFour < 500) {
            if (this.valueOfPlaceIndexFour < 50) {
              this.valueOfPlaceIndexFour = ((this.valueOfPlaceIndexFour + 760) - (this.differenceOfLocationslengthIndexFour - this.nearbyStopPointFourthAngle));
            } else if (this.valueOfPlaceIndexFour < 200 && this.valueOfPlaceIndexFour > 50) {
              if (this.valueOfPlaceIndexFour > 100 && this.differenceOfLocationslengthIndexFour > 100) {

                if (this.totalItems === 6 || this.totalItems === 5) {
                  if (this.screenSize <= 1920) {
                    this.valueOfPlaceIndexFourTop = 350;
                  } else {
                    this.valueOfPlaceIndexFourTop = 400;
                  }
                }
              }
              this.valueOfPlaceIndexFour = this.placeIndexFour;
              if (this.placeIndexOne < 70 && this.nearbyStopPointFourthAngle < 40) {

                this.valueOfPlaceIndexFour = (((this.valueOfPlaceIndexFour + 580) + (this.differenceOfLocationslengthIndexFour)) - this.nearbyStopPointFourthAngle);
              } else {
                this.valueOfPlaceIndexFour = ((this.valueOfPlaceIndexFour + 640) - (this.differenceOfLocationslengthIndexFour - this.nearbyStopPointFourthAngle));
              }
            } else {
              if (this.screenSize <= 1920) {
                this.valueOfPlaceIndexFour = 715;
              } else {
                this.valueOfPlaceIndexFour = 730;
              }
            }
          } else {
            this.valueOfPlaceIndexFour = 650;
          }
        } else {
          this.valueOfPlaceIndexFour = 650;
        }

        if (this.placeIndexOne > this.placeIndexFour) {
          this.valueOfPlaceIndexFour = this.placeIndexFour;
          if (this.differenceOfLocationslengthIndexFour < 500) {

            if (this.placeIndexOne > this.placeIndexFour && this.nearbyStopPointFourthAngle <= 18 && this.nearbyStopPointFourthAngle > 0 && this.differenceOfLocationslengthIndexFour > this.placeIndexFour) {
              this.valueOfPlaceIndexFour = this.valueOfPlaceIndexFour + 760;
            } else if (this.placeIndexOne < this.placeIndexFour && this.nearbyStopPointFourthAngle >= 20 && this.nearbyStopPointFourthAngle < 50 && this.differenceOfLocationslengthIndexFour < this.placeIndexFour) {
              this.valueOfPlaceIndexFour = this.placeIndexFour;
              this.valueOfPlaceIndexFour = this.valueOfPlaceIndexFour + 760;
            } else if (this.placeIndexOne > this.placeIndexFour && this.nearbyStopPointFourthAngle >= 50 && this.nearbyStopPointFourthAngle < 80 && this.differenceOfLocationslengthIndexFour > this.placeIndexFour) {
              this.valueOfPlaceIndexFour = this.placeIndexFour;
              if (this.placeIndexFour < 150) {
                 this.valueOfPlaceIndexFour = this.valueOfPlaceIndexFour + 800;
              }
              if (this.placeIndexFour > 150) {
                 this.valueOfPlaceIndexFour = this.valueOfPlaceIndexFour + 550;
              }
            } else {
              this.valueOfPlaceIndexFour = 695;
            }
          } else {
            this.valueOfPlaceIndexFour = 700;
          }
        } else {
          this.valueOfPlaceIndexFour = 700;
        }

        if (this.placeIndexTwo < this.placeIndexThree) {
            this.valueOfPlaceIndexThree = 490;
        } else {
          this.valueOfPlaceIndexThree = 490;
        }
        if (this.placeIndexTwo > this.placeIndexThree) {
          if (this.differenceOfLocationslengthIndexThree > 150 && this.nearbyStopPointThirdAngle > 50 ) {
            this.valueOfPlaceIndexThree = 600;
          } else {
            this.valueOfPlaceIndexThree = 540;
          }
        } else {
          this.valueOfPlaceIndexThree = 540;
        }
        if (response.ServiceDelivery.StopMonitoringDelivery.MonitoredStopVisit.length > 0) {
          response.ServiceDelivery.StopMonitoringDelivery.MonitoredStopVisit.forEach((stopData) => {
            this.routeKeys = [];
            formatRoutesDataKeys.push(stopData.MonitoredVehicleJourney);
          });

          if (formatRoutesDataKeys.length >= 1) {

            formatByRouteData = this.routsGroupByDataKey(formatRoutesDataKeys, 'LineRef');

            formatedRoutesData = Object.values(formatByRouteData).map((routeData: any) => {

              Object.assign(routeData, ...routeData);

              routeData.forEach((routeDataAdd: any) => {

                if (routeDataAdd.MonitoredCall.ExpectedArrivalTime != null && routeDataAdd.MonitoredCall.ExpectedArrivalTime.length > 4) {
                  if (routeDataAdd.MonitoredCall.ExpectedDepartureTime) {
                    routeDataAdd.MonitoredCall.ExpectedArrivalTime = this.getLocalTime(routeDataAdd.MonitoredCall.ExpectedDepartureTime, response.ServiceDelivery.ResponseTimestamp);
                  } else {
                    routeDataAdd.MonitoredCall.ExpectedArrivalTime = this.getLocalTime(routeDataAdd.MonitoredCall.ExpectedArrivalTime, response.ServiceDelivery.ResponseTimestamp);
                  }

                }
                routeDataAdd.operatorName = operatorRef;
              });

              let sortByRoutesData: any = [];
              let i = 0;

              if (routeData.length >= 2) {
                // We need to show two Predictions only
                if (i <= 2) {
                  const routeData1 = routeData[0];
                  const routeData2 = routeData[1];
                  const twoRoutesData = [];
                  twoRoutesData.push(routeData1, routeData2);
                  sortByRoutesData = twoRoutesData.slice().sort((a: any, b: any) => a.MonitoredCall.ExpectedArrivalTime - b.MonitoredCall.ExpectedArrivalTime);
                  i ++;
                }

              } else {
                sortByRoutesData = routeData;
              }

              return sortByRoutesData;

            });

          }

          formatedRoutesData.sort((a: any, b: any) => {
            return a[0].LineRef.localeCompare(b[0].LineRef, undefined, {
              numeric: true,
            });
          });

          this.routeKeys = formatedRoutesData;
          this.bubbles = true;
          this.noPredictionBubbles = false;
          let popupOffsets: any = [];

          popupOffsets = [[0, 0], [-640, -70], [490, -100], [this.valueOfPlaceIndexThree, 460], [-this.valueOfPlaceIndexFour, this.valueOfPlaceIndexFourTop], [-170, -150], [880, 150]];

          if (this.popupBlock) {
            if (this.routeKeys.length >= 1) {
              this.bubbleAlignment(this.screenSize, this.totalStopCodes.length, this.routeKeys.length);
              if (this.map.getContainer().querySelector('.prediction-' + totalItems + ' ' + '.mapboxgl-popup-content') !== null) {
                const removeBubble = this.map.getContainer().querySelector('.prediction-' + totalItems + ' ' + '.mapboxgl-popup-content');
                if (removeBubble != null) {
                    removeBubble.remove();
                }
                const refreshDom = this.map.getContainer().querySelector('.prediction-' + totalItems);
                let html = `<div class="mapboxgl-popup-tip"></div>`;
                html += `<div class="mapboxgl-popup-content ${(this.screenBubbleAlignCss === true) ? 'zoom-xl-45-inline' : 'empty'} ${(this.screenBubbleAlignCssMd === true) ? 'zoom-xl-12-inline' : 'xl-12-empty'}">`;
                this.routeKeys.forEach((route: any, i: any) => {
                  if (i === 0) {
                    html += `<span><div class="operatorHeader">${route[0].MonitoredCall.StopPointName + `<span class="minNormal">${' #' + route[0].MonitoredCall.StopPointRef}</span>`}</div></span>`;
                  }
                  html += `<div class="bubble-container">`;
                  if (this.routeKeys.length !== 1 && route.length === 1) {
                    html += `<span>`;
                    html += `<div class="bubbles_one" style="width: 45px;">
                            <div class="circles ${((route[0].LineRef).length > 2) ? 'circles_xs_font' : 'circle'}">
                            <div>${route[0].LineRef}</div>
                            </div>
                            </div>`;

                    if (route[0].MonitoredCall.DestinationDisplay != null) {
                      html += `<div class="bubbles_second"> ${route[0].MonitoredCall.DestinationDisplay} </div>`;

                    }

                    if (route[0].MonitoredCall.ExpectedArrivalTime != null) {
                      html += `<div class="bubbles_last"> ${route[0].MonitoredCall.ExpectedArrivalTime} <span class="minNormal">min</span></div>`;

                    }

                    html += `</span>`;
                  }

                  if (this.routeKeys.length === 1 && route.length === 1) {
                    html += `<span>`;
                    html += `<div class="bubbles_one" style="width: 45px;">
                            <div class="circles ${((route[0].LineRef).length > 2) ? 'circles_xs_font' : 'circle'}">
                            <div>${route[0].LineRef} </div>
                            </div>
                            </div>`;

                    if (route[0].MonitoredCall.DestinationDisplay != null) {
                      html += `<div class="bubbles_second">${route[0].MonitoredCall.DestinationDisplay}</div>`;
                    }

                    if (route[0].MonitoredCall.ExpectedArrivalTime != null) {
                      html += `<div class="bubbles_last">${route[0].MonitoredCall.ExpectedArrivalTime} <span class="minNormal">min</span></div>`;

                    }
                    html += `</span>`;
                  }
                  if (route.length > 1) {
                    html += `<span>`;
                    html += `<div class="bubbles_one" style="width: 45px;">
                            <div class="circles ${((route[0].LineRef).length > 2) ? 'circles_xs_font' : 'circle'}">
                            <div>${route[0].LineRef}</div>
                            </div>
                            </div>`;

                    if (route[0].MonitoredCall.DestinationDisplay != null) {
                      html += `<div class="bubbles_second">${route[0].MonitoredCall.DestinationDisplay} </div>`;
                    }

                    if (route.length > 1) {
                      html += `<div class="bubbles_last">`;
                      html += `<span>`;
                      if (route[0].MonitoredCall.ExpectedArrivalTime != null) {
                         html += `<span>${route[0].MonitoredCall.ExpectedArrivalTime}</span>`;
                      }
                      if (route[0].MonitoredCall.ExpectedArrivalTime != null && route[1].MonitoredCall.ExpectedArrivalTime != null) {
                        html += `<span>, </span>`;
                      }
                      if (route[0].MonitoredCall.ExpectedArrivalTime === null) {
                        html += `<span></span>`;
                      }
                      if (route[1].MonitoredCall.ExpectedArrivalTime != null) {
                        html += `<span>${route[1].MonitoredCall.ExpectedArrivalTime}</span>`;
                      }
                      if (route[1].MonitoredCall.ExpectedArrivalTime === null) {
                        html += `<span></span>`;
                      }
                      if (route[0].MonitoredCall.ExpectedArrivalTime != null || route[1].MonitoredCall.ExpectedArrivalTime != null) {
                        html += `<span>  <span class="minNormal">min</span></span>`;
                      }

                      html += `</span>`;
                      html += `</div>`;
                    }
                    html += `</span>`;
                  }

                  html += `</div>`;
                });

                html += `</div>`;
                refreshDom.innerHTML = html;

              }
            }
          } else {
            setTimeout(() => {
              this.popup = new mapboxgl.Popup({
                closeOnClick: false, closeButton: false, offset: Object(popupOffsets[totalItems]), anchor: 'bottom'
              }).setLngLat([longitude, latitude])
              .setHTML(this.nearByStopsPredictions.nativeElement.innerHTML)
              .addTo(this.map);
              this.popup.addClassName(this.bubbleCssClass[totalItems] + ' ' + 'prediction-' + totalItems);
              this.bubbleAlignment(this.screenSize, this.totalStopCodes.length, this.routeKeys.length);
              this.defaultPostionIndex ++;
            });
          }
          const predictionsArray = {
            agencyRf: agency,
            stopCodeRf: stopCode,
            longitudeRf: longitude,
            latitudeRf: latitude,
            totalItemsRf: totalItems,
            operatorRefRf: operatorRef,
          };

          this.refreshPredictionsArray.push(predictionsArray);

        } else {

          this.bubbles = true;
          this.noPredictionBubbles = true;
          let popupOffsets: any  = [];

          popupOffsets = [[0, 0], [-640, -70], [490, -100], [this.valueOfPlaceIndexThree, 460], [-this.valueOfPlaceIndexFour, this.valueOfPlaceIndexFourTop], [-170, -150], [880, 150]];

          this.noMonitoredVehicleJourney = [{
            stopCodeOff: stopCode,
            operatorName: operatorRef,
          }];
          if (this.popupBlock) {
            this.bubbleAlignment(this.screenSize, this.totalStopCodes.length, this.routeKeys.length);
            if (this.map.getContainer().querySelector('.prediction-' + totalItems + ' ' + '.mapboxgl-popup-content') !== null) {
              const removeBubble = this.map.getContainer().querySelector('.prediction-' + totalItems + ' ' + '.mapboxgl-popup-content');
              if (removeBubble != null) {
                  removeBubble.remove();
              }
              const refreshDom = this.map.getContainer().querySelector('.prediction-' + totalItems);
              let html = `<div class="mapboxgl-popup-tip"></div>`;
              html += `<div class="mapboxgl-popup-content ${(this.screenBubbleAlignCss === true) ? 'zoom-xl-45-inline' : 'empty'} ${(this.screenBubbleAlignCssMd === true) ? 'zoom-xl-12-inline' : 'xl-12-empty'}">`;
              this.noMonitoredVehicleJourney.forEach((route: any) => {
                html += `<div class="operatorHeader">${route.operatorName + `<span class="minNormal">${' #' + route.stopCodeOff}</span>`}</div>`;
                html += `<div class="bubble-container">
                        <div>
                        <div class="bubbles_second" style="width: 420px;">${route.stopCodeOff}<span class="offline_nodata"> Offline! no information available</span></div>
                        <div class="bubbles_last" style="text-align: center;">-- --</div>
                        </div>`;

                html += `</div>`;
              });
              html += `</div>`;
              refreshDom.innerHTML = html;
            }
            this.bubbleAlignment(this.screenSize, this.totalStopCodes.length, this.noMonitoredVehicleJourney.length);
          } else {
            setTimeout(() => {
              this.popup = new mapboxgl.Popup({
                closeOnClick: false, closeButton: false, offset: Object(popupOffsets[totalItems]), anchor: 'bottom'
              }).setLngLat([longitude, latitude])
              .setHTML(this.nearByStopsPredictions.nativeElement.innerHTML)
              .addTo(this.map);
              this.popup.addClassName(this.bubbleCssClass[totalItems] + ' ' + 'prediction-' + totalItems);
              this.bubbleAlignment(this.screenSize, this.totalStopCodes.length, this.noMonitoredVehicleJourney.length);
              this.defaultPostionIndex ++;
            });

          }

          const predictionsArray = {
            agencyRf: agency,
            stopCodeRf: stopCode,
            longitudeRf: longitude,
            latitudeRf: latitude,
            totalItemsRf: totalItems,
            operatorRefRf: operatorRef,
          };

          this.refreshPredictionsArray.push(predictionsArray);
        }

      },
      (error: any) => console.log(error),
      () => {},
    );

  }

  public getStopPredictionsNbIq(agency: string, stopCode: string, longitude: number, latitude: number, totalItems: number, stopPostionIndexValue: number): void {

    this.mapsService.stopPredictionsNbIq(agency, stopCode).subscribe(
      (response: AllStopsNBIQ) => {

        this.stopTimes = [];
        this.routeColor = [];
        this.routeKeysNbIq = [];

        this.screenSize = document.body.offsetWidth;

        const signedLocationGeo: any = {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [this.signedLocationLon, this.signedLocationLat]
          }
        };
        const nearbyStopPoint: any = {
        type: 'Feature',
        geometry: {
            type: 'Point',
            coordinates: [longitude, latitude]
          }
        };

        const units: any = 'miles';
        let differenceOfLocations = (turf.distance(signedLocationGeo, nearbyStopPoint, units)) * 1000;
        differenceOfLocations = Math.floor(differenceOfLocations);
        if (this.defaultPostionIndex === 1) {
          this.nearbyStopPointOne = {
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: [longitude, latitude]
            }
          };
          this.placeIndexOne = differenceOfLocations;
        }

        if (this.defaultPostionIndex === 2) {
          this.nearbyStopPointTwo = {
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: [longitude, latitude]
            }
          };
          this.placeIndexTwo = differenceOfLocations;
        }

        if (this.defaultPostionIndex === 3) {
          this.placeIndexThree = differenceOfLocations;
          const nearbyStopPointThree: any = {
            type: 'Feature',
            geometry: {
                type: 'Point',
                coordinates: [longitude, latitude]
              }
          };
          if (this.nearbyStopPointTwo && this.placeIndexTwo) {
            this.differenceOfLocationslengthIndexThree = (turf.distance(this.nearbyStopPointTwo, nearbyStopPointThree, units)) * 1000;
            this.differenceOfLocationslengthIndexThree = Math.floor(this.differenceOfLocationslengthIndexThree);
            this.nearbyStopPointThirdAngle = Math.acos((((this.placeIndexThree * this.placeIndexThree) + (this.differenceOfLocationslengthIndexThree * this.differenceOfLocationslengthIndexThree)) - (this.placeIndexTwo * this.placeIndexTwo)) / (2 * this.placeIndexThree * this.differenceOfLocationslengthIndexThree));
            this.nearbyStopPointThirdAngle = Math.floor(this.nearbyStopPointThirdAngle * (180 / Math.PI));
          }
        }

        if (this.defaultPostionIndex === 4) {
          this.placeIndexFour = differenceOfLocations;
          const nearbyStopPointFoure: any = {
          type: 'Feature',
          geometry: {
              type: 'Point',
              coordinates: [longitude, latitude]
            }
          };
          if (this.nearbyStopPointOne && this.placeIndexOne) {
            this.differenceOfLocationslengthIndexFour = (turf.distance(this.nearbyStopPointOne, nearbyStopPointFoure, units)) * 1000;
            this.differenceOfLocationslengthIndexFour = Math.floor(this.differenceOfLocationslengthIndexFour);
            this.nearbyStopPointFourthAngle = Math.acos((((this.placeIndexFour * this.placeIndexFour) + (this.differenceOfLocationslengthIndexFour * this.differenceOfLocationslengthIndexFour)) - (this.placeIndexOne * this.placeIndexOne)) / (2 * this.placeIndexFour * this.differenceOfLocationslengthIndexFour));
            this.nearbyStopPointFourthAngle = Math.floor(this.nearbyStopPointFourthAngle * (180 / Math.PI));
          }
        }

        [response].forEach((stopPredictionsNBIQ: any) => {

          this.routeKeysNbIq = [];
          this.routeKeysNoDataNbIq = [];
          stopPredictionsNBIQ.forEach((routesData: any) =>  {
          if (routesData.values.length >= 1) {
            this.routeKeysNbIq.push(routesData);
            }
          });

          if (this.routeKeysNbIq.length === 0) {

            this.routeKeysNoDataCN = true;

            const routeKeysNoDataNewNbIq = {
                short_name: stopPredictionsNBIQ[0].agency.shortName,
                stop_code: stopPredictionsNBIQ[0].stop.code,
                stop_name: stopPredictionsNBIQ[0].stop.name,
            };

            this.routeKeysNoDataNbIq.push(routeKeysNoDataNewNbIq);

          }

          this.routeKeysNbIq.sort((a: any, b: any) => {
            return a.route.id.localeCompare(b.route.id, undefined, {
              numeric: true,
            });
          });

          this.bubblesNbIq = true;
          let popupOffsets: any = [];
          if (this.placeIndexOne < this.placeIndexFour) {
            this.valueOfPlaceIndexFour = this.placeIndexFour;
            if (this.differenceOfLocationslengthIndexFour < 500) {
              if (this.valueOfPlaceIndexFour < 50) {
                this.valueOfPlaceIndexFour = ((this.valueOfPlaceIndexFour + 760) - (this.differenceOfLocationslengthIndexFour - this.nearbyStopPointFourthAngle));
              } else if (this.valueOfPlaceIndexFour < 200 && this.valueOfPlaceIndexFour > 50) {
                if (this.valueOfPlaceIndexFour > 100 && this.differenceOfLocationslengthIndexFour > 100) {
                  if (this.totalItems === 6 || this.totalItems === 5) {
                    if (this.screenSize <= 1920) {
                      this.valueOfPlaceIndexFourTop = 350;
                    } else {
                      this.valueOfPlaceIndexFourTop = 400;
                    }
                  }
                }
                this.valueOfPlaceIndexFour = this.placeIndexFour;
                if (this.placeIndexOne < 70 && this.nearbyStopPointFourthAngle < 40) {
                  this.valueOfPlaceIndexFour = (((this.valueOfPlaceIndexFour + 580) + (this.differenceOfLocationslengthIndexFour)) - this.nearbyStopPointFourthAngle);
                } else {
                  this.valueOfPlaceIndexFour = ((this.valueOfPlaceIndexFour + 640) - (this.differenceOfLocationslengthIndexFour - this.nearbyStopPointFourthAngle));
                }
              } else {
                if (this.screenSize <= 1920) {
                  this.valueOfPlaceIndexFour = 715;
                } else {
                  this.valueOfPlaceIndexFour = 730;
                }
              }
            } else {
              this.valueOfPlaceIndexFour = 650;
            }
          } else {
            this.valueOfPlaceIndexFour = 650;
          }
          if (this.placeIndexOne > this.placeIndexFour) {
            this.valueOfPlaceIndexFour = this.placeIndexFour;
            if (this.differenceOfLocationslengthIndexFour < 500) {
              if (this.placeIndexOne > this.placeIndexFour && this.nearbyStopPointFourthAngle <= 18 && this.nearbyStopPointFourthAngle > 0 && this.differenceOfLocationslengthIndexFour > this.placeIndexFour) {
                this.valueOfPlaceIndexFour = this.valueOfPlaceIndexFour + 760;
              } else if (this.placeIndexOne < this.placeIndexFour && this.nearbyStopPointFourthAngle >= 20 && this.nearbyStopPointFourthAngle < 50 && this.differenceOfLocationslengthIndexFour < this.placeIndexFour) {
                this.valueOfPlaceIndexFour = this.placeIndexFour;
                this.valueOfPlaceIndexFour = this.valueOfPlaceIndexFour + 760;
              } else if (this.placeIndexOne > this.placeIndexFour && this.nearbyStopPointFourthAngle >= 50 && this.nearbyStopPointFourthAngle < 80 && this.differenceOfLocationslengthIndexFour > this.placeIndexFour) {
                this.valueOfPlaceIndexFour = this.placeIndexFour;
                if (this.placeIndexFour < 150) {
                  this.valueOfPlaceIndexFour = this.valueOfPlaceIndexFour + 800;
                }
                if (this.placeIndexFour > 150) {
                  this.valueOfPlaceIndexFour = this.valueOfPlaceIndexFour + 550;
                }
              } else {
                this.valueOfPlaceIndexFour = 800;
              }
            } else {
              this.valueOfPlaceIndexFour = 700;
            }
          } else {
            this.valueOfPlaceIndexFour = 700;
          }
          if (this.placeIndexTwo < this.placeIndexThree) {
            this.valueOfPlaceIndexThree = 490;
          } else {
            this.valueOfPlaceIndexThree = 490;
          }
          if (this.placeIndexTwo > this.placeIndexThree) {
            if (this.differenceOfLocationslengthIndexThree > 150 && this.nearbyStopPointThirdAngle > 50) {
              this.valueOfPlaceIndexThree = 600;
            } else {
              this.valueOfPlaceIndexThree = 540;
            }
          } else {
            this.valueOfPlaceIndexThree = 540;
          }
          popupOffsets = [[0, 0], [-640, -70], [490, -100], [this.valueOfPlaceIndexThree, 460], [-this.valueOfPlaceIndexFour, this.valueOfPlaceIndexFourTop], [-170, -150], [880, 150]];

          if (this.popupBlock) {
            this.bubbleAlignment(this.screenSize, this.totalStopCodes.length, this.routeKeysNbIq.length);
            if (this.routeKeysNbIq.length > 0) {
              if (this.map.getContainer().querySelector('.prediction-' + totalItems + ' ' + '.mapboxgl-popup-content') !== null) {
                const removeBubble = this.map.getContainer().querySelector('.prediction-' + totalItems + ' ' + '.mapboxgl-popup-content');
                if (removeBubble != null) {
                    removeBubble.remove();
                }
                const refreshDom = this.map.getContainer().querySelector('.prediction-' + totalItems);
                let html = `<div class="mapboxgl-popup-tip"></div>`;
                html += `<div class="mapboxgl-popup-content ${(this.screenBubbleAlignCss === true) ? 'zoom-xl-45-inline' : 'empty'} ${(this.screenBubbleAlignCssMd === true) ? 'zoom-xl-12-inline' : 'xl-12-empty'}">`;
                this.routeKeysNbIq.forEach((route: any, i: any) => {
                  if (i === 0) {
                    html += `<div class="operatorHeader">${route.stop.name + `<span class="minNormal">${' #' + route.stop.code}</span>`}</div>`;
                  }
                  html += `<div class="bubble-container">`;
                  html += `<div class="bubbles_one" style="width: 45px;">
                           <div class="circles ${((route.route.id).length > 2) ? 'circles_xs_font' : 'circle'}" style="background-color: #${route.route.color}">
                           <div>${route.route.id}</div>
                           </div>
                           </div>`;
                  if (route.values.length > 0) {
                    html += `<span><div class="bubbles_second">${route.values[0].direction.name}</div>`;
                    if (route.values.length === 1) {
                      html += `<div class="bubbles_last"><span>${route.values[0].minutes}<span class="minNormal"> min</span> </span></div> </span>`;
                    }
                    if (route.values.length > 1) {
                      html += `<div class="bubbles_last"><span>${route.values[0].minutes}, ${route.values[1].minutes}<span class="minNormal"> min</span> </span></div> </span>`;
                    }
                  }
                  html += `</div>`;
                });
                html += `</div>`;
                refreshDom.innerHTML = html;
              }
            }

            if (this.routeKeysNbIq.length === 0) {

              if (this.map.getContainer().querySelector('.prediction-' + totalItems + ' ' + '.mapboxgl-popup-content') !== null) {
                const removeBubble = this.map.getContainer().querySelector('.prediction-' + totalItems + ' ' + '.mapboxgl-popup-content');

                if (removeBubble != null) {
                    removeBubble.remove();
                }
                const refreshDom = this.map.getContainer().querySelector('.prediction-' + totalItems);
                let html = `<div class="mapboxgl-popup-tip"></div>`;

                html += `<div class="mapboxgl-popup-content ${(this.screenBubbleAlignCss === true) ? 'zoom-xl-45-inline' : 'empty'} ${(this.screenBubbleAlignCssMd === true) ? 'zoom-xl-12-inline' : 'xl-12-empty'}">`;

                this.routeKeysNoDataNbIq.forEach((route: any, i: any) => {
                  if (i === 0) {
                    html += `<div class="operatorHeader">${route.short_name + `<span class="minNormal">${' #' + route.stop_code}</span>`}</div>`;
                  }
                  html += `<div class="bubble-container">`;
                  html += `<div>
                          <div class="bubbles_second" style="width: 420px;"> ${route.stop_code}<span class="offline_nodata">Offline! no information available</span></div>
                          <div class="bubbles_last" style="text-align: center;">-- --</div>
                          </div>
                          </div>`;

                });

                html += `</div>`;
                refreshDom.innerHTML = html;
              }

            }
          } else {

            setTimeout(() => {
              this.popup = new mapboxgl.Popup({
                closeOnClick: false, closeButton: false, offset: Object(popupOffsets[totalItems]), anchor: 'bottom'
              });
              this.popup.setLngLat([longitude, latitude])
              .setHTML(this.nearByStopsPredictionsNbIq.nativeElement.innerHTML);
              this.popup.addTo(this.map);
              this.popup.addClassName(this.bubbleCssClass[totalItems] + ' ' + 'prediction-' + totalItems);
              this.bubbleAlignment(this.screenSize, this.totalStopCodes.length, this.routeKeysNbIq.length);
              this.defaultPostionIndex ++;
            });

          }

          const predictionsArray = {
            agencyNb: agency,
            stopCodeNb: stopCode,
            longitudeNb: longitude,
            latitudeNb: latitude,
            totalItemsNb: totalItems,
            stopPostionIndexValueNb: stopPostionIndexValue,
          };
          this.refreshPredictionsArrayNbIq.push(predictionsArray);
        });
      },
      (error: any) => {
        this.routeKeysNoDataFail = true;
        this.routeKeysNoDataNbIq = [{stopCode}];
      },
      () => {}
    );
  }

  public stopLocation(stopLon: number, stopLat: number): void {

    const el = document.createElement('div');
    el.id = 'marker';

    setTimeout(() => {

      new mapboxgl.Marker(el).setLngLat([stopLon, stopLat]).addTo(this.map);

      switch (true) {
        case this.getParamLng && this.getParamLng != null && this.getParamLat && this.getParamLat != null && this.getParamZoom && this.getParamZoom != null:
          stopLon = this.getParamLng;
          stopLat = this.getParamLat;
          this.zoomLevel = this.getParamZoom;
          break;

        case this.getParamLng && this.getParamLng != null && this.getParamLat && this.getParamLat != null && !this.getParamZoom && this.getParamZoom === null:
          stopLon = this.getParamLng;
          stopLat = this.getParamLat;
          break;

        case !this.getParamLng && this.getParamLng === null && this.getParamLat && this.getParamLat != null && this.getParamZoom && this.getParamZoom != null:
          stopLon = this.getParamLat;
          this.zoomLevel = this.getParamZoom;
          break;

        case this.getParamLng && this.getParamLng != null && !this.getParamLat && this.getParamLat === null && this.getParamZoom && this.getParamZoom != null:
          stopLon = this.getParamLng;
          this.zoomLevel = this.getParamZoom;
          break;

      }

      this.map.flyTo({
        center: [stopLon, stopLat],
        zoom: this.zoomLevel
      });
    }, 800);
  }

  public mapWidth(): void {
    this.innerWidth = window.innerWidth;
  }

  public getLocalTime = (utcTime: string, ResponseTimestamp: any) => {

    const localTime = moment.utc(utcTime).diff(moment.utc(ResponseTimestamp), 'minutes');
    return localTime;

  }

  public parentMousewheel(): void {
    this.getParams = false;
    const newZoom = this.map.getZoom();
    const setLng = this.map.getCenter().lng.toFixed(4);
    const setLat = this.map.getCenter().lat.toFixed(4);
    const paramsObj: any = { lng: setLng, lat: setLat, zoomvalue: newZoom.toFixed(2)};
    const urlTree = this.router.createUrlTree([], {
      queryParams: paramsObj,
      queryParamsHandling: 'merge',
      preserveFragment: true
    });
    this.router.navigateByUrl(urlTree);
  }

  public routsGroupByDataKey(lineData: any, routKey: string): any {
    return lineData
      .reduce((hash: any, obj: any) => {

        if (obj[routKey] === undefined) {
          return hash;
        }
        return Object.assign(hash, {[obj[routKey]]: ( hash[obj[routKey]] || [] ).concat(obj)});
      }, {});
  }

  public getNearByStopPoints(nearByStopLocationLon: number,  nearByStopLocationLat: number): void {
    const signedLocationGeo: any = {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [this.signedLocationLon, this.signedLocationLat]
      }
    };

    const nearbyStopPoint: any = {
    type: 'Feature',
    geometry: {
        type: 'Point',
        coordinates: [nearByStopLocationLon, nearByStopLocationLat]
      }
    };

    this.nearbyEachStopSource.push({
        type: 'Feature',
        properties: {
          description: ''
        },
        geometry: {
          type: 'Point',
          coordinates: [ nearByStopLocationLon, nearByStopLocationLat]
        }

    });

    this.bubbleCssClass = [
      'bubbleTopLeft',
      'bubbleBottom',
      'bubbleRight',
      this.addLineIndexThree,
      this.addLineIndexFour,
      'bubbleBottomRight',
      'bubbleBottomLeft',
      'bubbleTopRight',
    ];

    const units: any = 'miles';
    const differenceOfLocations = turf.distance(signedLocationGeo, nearbyStopPoint, units);
    this.distanceOfSignedLocation.push(differenceOfLocations.toFixed(3));
    this.getZoomLevel();
  }
  public getZoomLevel(): void {

    this.distanceOfSignedLocation.sort((a: any, b: any) => (b) - (a));
    const distance = this.distanceOfSignedLocation[0] * 100;

    switch (distance > 0) {

      case distance > 0 && distance <= 6:
           this.zoomLevel = 18;
           break;

      case distance > 6 && distance <= 10:
           this.zoomLevel = 17;
           break;

      case distance > 10 && distance <= 20:
           this.zoomLevel = 16;
           break;

      case distance > 20 && distance <= 30:
           this.zoomLevel = 15;
           break;

      case distance > 30 && distance <= 50:
           this.zoomLevel = 14;
           break;

      case distance > 50:
           this.zoomLevel = 13;
           break;
    }

  }

  public bubbleAlignment(screenSize: number, totalItems: number, routeKeysLength: number): void {

    if (totalItems === 2 || totalItems === 3) {
      if (screenSize <= 1920) {
        if (routeKeysLength >= 4) {
          this.popup.addClassName('zoom-xl-12');
        }
      }
    }
    if (totalItems === 4 || totalItems === 5) {
      if (screenSize <= 1920) {
        if (routeKeysLength >= 1) {
          this.popup.addClassName('zoom-xl-12');
        }
        if (routeKeysLength >= 4) {
          this.screenBubbleAlignCss = true;
          this.popup.addClassName('zoom-xl-45');
        }
      }

      if (screenSize > 1920) {
        if (routeKeysLength >= 5) {
          this.screenBubbleAlignCssMd = true;
          this.popup.addClassName('zoom-xl-12');
        }
      }
    }

    if (totalItems === 6) {
      if (screenSize <= 1920) {
        if (routeKeysLength >= 1) {
          this.popup.addClassName('zoom-xl-12');
        }
        if (routeKeysLength >= 4) {
          this.screenBubbleAlignCss = true;
          this.popup.addClassName('zoom-xl-45');
        }
      }

      if (screenSize > 1920) {
        if (routeKeysLength >= 5) {
          this.screenBubbleAlignCssMd = true;
          this.popup.addClassName('zoom-xl-12');
        }
      }
    }
  }

}
